import type { ReactNode } from 'react';

export const symbol_lock_open_right: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-140h520v-434H220v434Zm314.5-162.03Q557-324.06 557-355q0-30-22.67-54.5t-54.5-24.5q-31.83 0-54.33 24.5t-22.5 55q0 30.5 22.67 52.5t54.5 22q31.83 0 54.33-22.03ZM220-140v-434 434Zm0 60q-24.75 0-42.37-17.63Q160-115.25 160-140v-434q0-24.75 17.63-42.38Q195.25-634 220-634h330v-96q0-78.85 55.58-134.42Q661.15-920 740-920q71 0 123 44.5T927-765q2 12-6.62 23.5-8.63 11.5-20.63 11.5-12.75 0-21.25-6T868-755q-9-45-44.7-75T740-860q-54.17 0-92.08 37.92Q610-784.17 610-730v96h130q24.75 0 42.38 17.62Q800-598.75 800-574v434q0 24.75-17.62 42.37Q764.75-80 740-80H220Z"
		/>
	</svg>
);
